var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrEr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.274 10V0.76H6.196V1.74H1.366V4.568H5.062V5.548H1.366V9.02H6.364V10H0.274ZM15.4137 10H14.1397L11.2697 6.122H9.29569V10H8.20369V0.76H11.4517C12.3384 0.76 13.0524 1.012 13.5937 1.516C14.135 2.01067 14.4057 2.65 14.4057 3.434C14.4057 4.05933 14.233 4.60067 13.8877 5.058C13.5424 5.506 13.0664 5.81867 12.4597 5.996L15.4137 10ZM9.29569 1.74V5.142H11.4097C11.9977 5.142 12.455 4.99267 12.7817 4.694C13.1084 4.386 13.2717 3.97067 13.2717 3.448C13.2717 2.93467 13.1037 2.524 12.7677 2.216C12.441 1.89867 11.9884 1.74 11.4097 1.74H9.29569Z",
    fill: "#DD4242"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrEr);
export default __webpack_public_path__ + "static/media/cr_er.495a8d33.svg";
export { ForwardRef as ReactComponent };